export function Ratio9x16Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="5" y="1.25" width="10" height="17.5" rx="2" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio9x16Icon.displayName = 'Ratio9x16Icon';
